import { gql } from '@apollo/client';

export const GET_ALL_USERS = gql`
  query GetAllUsers {
    users {
      edges {
        node {
          id
          name
          partner {
            image128
          }
        }
      }
    }
  }
`;

export interface GetAllUsersData {
  users: {
    edges: {
      node: {
        id: string;
        name: string;
        partner: { image128: string } | null;
      };
    }[];
  };
}
